import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isAfter, isValid, parse, startOfDay } from 'date-fns';

interface DateRangeValidatorOptions {
  startDateName: string;

  endDateName: string;

  format?: string;
}

export function dateRangeValidator(options: Partial<DateRangeValidatorOptions> = {}): ValidatorFn {
  const input: DateRangeValidatorOptions = {
    startDateName: 'startDate',
    endDateName: 'endDate',
    format: 'dd-MM-yyyy',
    ...options,
  };
  return (group: AbstractControl): ValidationErrors | null => {
    if (!(group instanceof FormGroup)) {
      throw new Error('this method use only used on formGroups');
    }

    if (!isValid(group.value[input.startDateName]) || !isValid(group.value[input.endDateName])) {
      return { tsRangeDateNotSet: { value: group } };
    }
    const start: string | Date = group.getRawValue()[input.startDateName];
    const end: string | Date = group.getRawValue()[input.endDateName];
    const startDate: Date =
      typeof start === 'string'
        ? parse(input.format as string, start, startOfDay(new Date()))
        : startOfDay(start);
    const endDate: Date =
      typeof end === 'string'
        ? parse(input.format as string, end, startOfDay(new Date()))
        : startOfDay(end);

    if (isAfter(startDate, endDate)) {
      return { tsRangeNotInRange: { value: group } };
    }
    return null;
  };
}
